// Sessions index — a hub that previews counts and routes into upcoming/past.
// Useful as a landing if the user lands on /patient-home/sessions directly
// (e.g. from the left rail). Most paths into sessions go straight to
// /upcoming so this page is mostly informational.

import React from 'react'
import { useNavigate } from 'react-router-dom'
import {
  Card,
  CardTitle,
  ContentMaxWidth,
  Muted,
  PageHeading,
  PageSubheading,
  Pill,
  Row,
  Stack,
} from '../../layout/styledComponents'
import { useSessionsList } from '../../hooks/useSessions'

export default function SessionsIndexPage() {
  const navigate = useNavigate()
  const upcoming = useSessionsList('upcoming')
  const past = useSessionsList('past')

  const upcomingCount = upcoming.data?.items?.length ?? null
  const pastCount = past.data?.items?.length ?? null

  return (
    <ContentMaxWidth>
      <Stack $gap="20px">
        <div>
          <Pill>Sessions</Pill>
          <PageHeading style={{ marginTop: 12 }}>Your sessions</PageHeading>
          <PageSubheading>Upcoming, past, and everything in between.</PageSubheading>
        </div>

        <Card
          as="button"
          onClick={() => navigate('/patient-home/sessions/upcoming')}
          style={{ textAlign: 'left', cursor: 'pointer', fontFamily: 'inherit' }}
        >
          <Row $between>
            <Row $gap="14px">
              <span style={{ fontSize: 24 }}>📅</span>
              <CardTitle style={{ margin: 0 }}>Upcoming</CardTitle>
            </Row>
            {upcomingCount !== null && (
              <Pill $tone={upcomingCount > 0 ? 'success' : 'primary'}>
                {upcomingCount} {upcomingCount === 1 ? 'session' : 'sessions'}
              </Pill>
            )}
          </Row>
          <Muted style={{ marginTop: 8 }}>Join, reschedule, or cancel.</Muted>
        </Card>

        <Card
          as="button"
          onClick={() => navigate('/patient-home/sessions/past')}
          style={{ textAlign: 'left', cursor: 'pointer', fontFamily: 'inherit' }}
        >
          <Row $between>
            <Row $gap="14px">
              <span style={{ fontSize: 24 }}>🗂️</span>
              <CardTitle style={{ margin: 0 }}>Past</CardTitle>
            </Row>
            {pastCount !== null && <Pill>{pastCount} completed</Pill>}
          </Row>
          <Muted style={{ marginTop: 8 }}>
            Recap, prescriptions, receipts, and feedback for sessions you&apos;ve had.
          </Muted>
        </Card>
      </Stack>
    </ContentMaxWidth>
  )
}
